import * as React from "react";

import { Product } from "../../../models";
import "./InfoForm.css";

export interface FormHeader {
  chosenProduct: Product;
  goBack: () => void;
}

const FormHeader = (props: FormHeader) => (
  <div className="info-form__header">
    <button
      className="info-form__header__back-btn info-form__header__shadow"
      onClick={props.goBack}
    >
      <i className="fa fa-caret-left icon" />
    </button>
    <h3 className="info-form__header__title info-form__header__shadow">
      <span className="info-form__header__product-label hidden-xs">
        Sản phẩm đã chọn:
      </span>
      <strong className="info-form__header__product-name">
        {props.chosenProduct.name}
      </strong>
    </h3>
  </div>
);

export default FormHeader;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/FormHeader.tsx